import Avatar from "@mui/material/Avatar";
import { borderWidths, sizes } from "et3-ui-library";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import i18n from "../../constants/i18n";

const KhatabaIcon = withLiteObserverAndTheme(() => {
  return (
    <Avatar
      src={require("../../assets/images/alkhattaba.png")}
      alt={i18n.get("ALKHATTABA_ADMIN")}
      sx={{
        width: sizes.avatar.lg,
        height: sizes.avatar.lg,
        flexShrink: 0,
        border: `${borderWidths.thin}px solid`,
        borderColor: "primary.main"
      }}
    />
  );
});
export default KhatabaIcon;
